import React from 'react'

const DONE = () => {
  return (
    <div>
        <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-slate-900 dark:border-gray-700 dark:shadow-slate-700/[.7] m-3">
            <div className=" md:p-5 p-20">
              
              <p className="mt-2 text-gray-800 font-medium dark:text-gray-400">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet lorem sit amet diam porta fringilla. 
              </p>
              
            </div>
            <div className="bg-gray-50 border-t rounded-b-xl py-3 px-4 md:py-4 md:px-5 dark:bg-slate-900 dark:border-gray-700">
              <div className='grid grid-cols-2 gap-[340px]'>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-500 w-80">
                Last updated 5 mins ago
              </p>
              <span className="inline-flex items-center justify-center size-[46px] text-sm font-semibold leading-none rounded-full bg-red-100 text-red-800 dark:bg-red-800/30 dark:text-red-500">
                BA
            </span>
              </div>
            </div>
          </div>
    </div>
  )
}

export default DONE